/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { adminintegration_TenantNotificationRequest } from "../models/adminintegration_TenantNotificationRequest"
import type { fastapi_Fi2Property } from "../models/fastapi_Fi2Property"
import type { integration_IntegrationPaidInvoicesRequest } from "../models/integration_IntegrationPaidInvoicesRequest"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class IntegrationAdminService {
    /**
     * Fetch all properties
     * Fetches all Properties from a specific FastAPI connector
     * @returns fastapi_Fi2Property OK
     * @throws ApiError
     */
    public static getV1AdminIntegrationFastapiConnectorProperties({
        connectorId,
    }: {
        /** Connector ID **/
        connectorId: number
    }): CancelablePromise<Array<fastapi_Fi2Property>> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v1/admin/integration/fastapi/connector/{connector_id}/properties",
            path: {
                connector_id: connectorId,
            },
        })
    }

    /**
     * Set invoice status as Paid in Avy platform
     * Set invoice status as Paid in Avy platform
     * @returns any Accepted
     * @throws ApiError
     */
    public static integrationInvoiceMarkAsPaid({
        request,
    }: {
        /** Request body **/
        request: integration_IntegrationPaidInvoicesRequest
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: "PATCH",
            url: "/v1/admin/integration/invoice/paid",
            body: request,
        })
    }

    /**
     * Send Tenant Notification
     * Send Tenant Notification Message
     * @returns any OK
     * @throws ApiError
     */
    public static tenantNotification({
        request,
    }: {
        /** Request body for tenant notifications **/
        request: adminintegration_TenantNotificationRequest
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v1/admin/integration/tenant-notification",
            body: request,
        })
    }
}
